/** Fee payments from a Bybit UID no client has connected, shared by every screen that warns of them. */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { readUnattributedFeeDeposits, type UnattributedDepositResponse } from "@/shared/api";

export function useUnattributedDeposits(): UseQueryResult<UnattributedDepositResponse[]> {
  return useQuery({
    queryKey: ["platform-unattributed-deposits"],
    retry: false,
    refetchInterval: 60_000,
    queryFn: async () => {
      const result = await readUnattributedFeeDeposits({ cache: "no-store" });
      if (result.data === undefined) throw new Error("unattributed deposits unavailable");
      return result.data;
    },
  });
}
